var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 261,
    viewBox: "0 0 284 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.0621 249.498C90.7421 252.319 93.5697 254.996 96.5329 257.517H224.285C238.372 244.125 251.707 224.902 263.391 198.331C263.391 198.331 284.085 145.937 279.267 100.01C274.45 54.0833 244.284 17.7912 201.553 10.0614C158.822 2.33169 120.84 44.7208 73.1469 59.416C25.4541 74.1112 -9.47739 113.495 3.07547 166.324C15.6283 219.152 50.6814 210.062 88.0621 249.498Z",
    fill: "#DAD9E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0986 100.358H251.226C252.832 100.358 254.373 100.996 255.509 102.131C256.644 103.267 257.283 104.808 257.283 106.414V249.139H28.048V106.408C28.0496 104.804 28.6875 103.266 29.8219 102.131C30.9563 100.997 32.4944 100.359 34.0986 100.358V100.358Z",
    fill: "white",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.966 111.978H37.3469V231.005H247.966V111.978Z",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.946 241.977H64.4154V249.735H221.946V241.977Z",
    fill: "#6E66FA",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.946 245.711H64.4154V249.736H221.946V245.711Z",
    fill: "white",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50821 254.333C9.50821 254.333 12.0964 257.5 19.8608 260.082H266.518C266.518 260.082 272.267 258.646 274.855 254.622L9.50821 254.333Z",
    fill: "#6E66FA",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.3 248.67H10.0815C9.47707 248.67 8.98713 249.16 8.98713 249.764V253.621C8.98713 254.225 9.47707 254.715 10.0815 254.715H274.3C274.904 254.715 275.394 254.225 275.394 253.621V249.764C275.394 249.16 274.904 248.67 274.3 248.67Z",
    fill: "white",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.619 104.856C144.621 104.458 144.503 104.068 144.283 103.735C144.062 103.403 143.748 103.144 143.38 102.991C143.012 102.837 142.606 102.797 142.215 102.874C141.824 102.951 141.464 103.142 141.182 103.424C140.899 103.705 140.707 104.064 140.629 104.455C140.55 104.846 140.59 105.252 140.742 105.62C140.895 105.989 141.153 106.304 141.484 106.526C141.816 106.747 142.206 106.866 142.604 106.866C143.138 106.866 143.65 106.654 144.027 106.277C144.405 105.901 144.618 105.39 144.619 104.856V104.856Z",
    fill: "white",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52372 260.082H283.5",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.878 134.316C161.579 133.617 162.097 132.755 162.387 131.808C162.677 130.861 162.729 129.857 162.54 128.885L158.747 132.672C158.531 132.884 158.24 133.003 157.937 133.003C157.633 133.003 157.342 132.884 157.126 132.672L153.976 129.522C153.764 129.306 153.645 129.015 153.645 128.711C153.645 128.408 153.764 128.117 153.976 127.901L157.763 124.108C156.704 123.905 155.609 123.988 154.593 124.35C153.577 124.711 152.676 125.338 151.984 126.164C151.291 126.991 150.832 127.988 150.654 129.052C150.476 130.115 150.585 131.207 150.971 132.214L141.186 141.774L140.242 140.83L141.782 139.29C141.855 139.211 141.895 139.108 141.895 139C141.895 138.893 141.855 138.79 141.782 138.711L140.59 137.524C140.512 137.449 140.408 137.407 140.3 137.407C140.192 137.407 140.088 137.449 140.011 137.524L139.432 138.103L138.14 136.818L138.638 136.32C138.739 136.212 138.795 136.07 138.795 135.923C138.795 135.776 138.739 135.634 138.638 135.526L127.961 124.85C127.707 124.595 127.405 124.393 127.073 124.256C126.741 124.118 126.384 124.047 126.025 124.047C125.665 124.047 125.309 124.118 124.976 124.256C124.644 124.393 124.342 124.595 124.088 124.85L122.999 125.938C122.745 126.192 122.543 126.494 122.405 126.827C122.268 127.159 122.197 127.515 122.197 127.875C122.197 128.235 122.268 128.591 122.405 128.923C122.543 129.255 122.745 129.557 122.999 129.812L133.676 140.488C133.784 140.589 133.925 140.646 134.073 140.646C134.22 140.646 134.362 140.589 134.469 140.488L134.962 139.991L136.253 141.282L135.674 141.861C135.599 141.938 135.557 142.042 135.557 142.15C135.557 142.258 135.599 142.362 135.674 142.44L136.832 143.632C136.911 143.705 137.014 143.745 137.121 143.745C137.228 143.745 137.332 143.705 137.411 143.632L138.951 142.092L139.877 143.019L131.771 150.934C130.764 150.546 129.671 150.435 128.607 150.612C127.542 150.789 126.545 151.248 125.717 151.942C124.89 152.635 124.263 153.537 123.903 154.554C123.542 155.571 123.46 156.666 123.665 157.726L127.458 153.939C127.674 153.727 127.965 153.608 128.268 153.608C128.571 153.608 128.862 153.727 129.079 153.939L132.229 157.089C132.441 157.305 132.56 157.596 132.56 157.899C132.56 158.202 132.441 158.493 132.229 158.71L128.442 162.502C129.501 162.706 130.595 162.622 131.611 162.261C132.628 161.899 133.529 161.273 134.221 160.446C134.914 159.62 135.373 158.623 135.551 157.559C135.729 156.495 135.619 155.403 135.234 154.396L143.34 146.487L154.399 157.546C154.241 157.955 154.205 158.402 154.295 158.832C154.385 159.261 154.598 159.655 154.908 159.966L157.578 162.635L160.78 159.434L158.11 156.764C157.799 156.454 157.405 156.241 156.976 156.151C156.546 156.061 156.1 156.097 155.69 156.255L144.631 145.248L154.41 135.7C155.506 136.122 156.702 136.216 157.85 135.97C158.998 135.724 160.051 135.15 160.878 134.316V134.316Z",
    fill: "#6E66FA",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 178.014C126.78 179.172 127.238 179.849 128.274 179.849C129.311 179.849 129.745 179.16 129.745 178.014V168.281H131.076V177.944C131.076 179.873 130.185 181.164 128.216 181.164C126.248 181.164 125.379 179.873 125.379 177.944V168.281H126.78V178.014Z",
    fill: "#6E66FA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.728 181.019H132.455V168.281H134.255L137.202 177.487V168.281H138.459V181.019H137.011L133.728 170.724V181.019Z",
    fill: "#6E66FA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.9 168.281C144.88 168.281 145.795 169.485 145.795 171.448V177.869C145.795 179.815 144.886 181.019 142.9 181.019H139.906V168.281H142.9ZM142.9 179.722C143.919 179.722 144.411 179.091 144.411 177.921V171.373C144.411 170.215 143.919 169.572 142.882 169.572H141.354V179.722H142.9Z",
    fill: "#6E66FA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.649 173.92V175.194H148.534V179.722H152.355V181.019H147.115V168.281H152.355V169.566H148.534V173.915L151.649 173.92Z",
    fill: "#6E66FA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.501 168.281C158.504 168.281 159.338 169.3 159.338 171.176V172.212C159.338 173.614 158.846 174.488 157.757 174.835C158.915 175.177 159.355 176.126 159.355 177.487V179.473C159.316 179.996 159.404 180.52 159.61 181.002H158.174C157.974 180.51 157.893 179.979 157.937 179.45V177.452C157.937 176.016 157.265 175.559 156.084 175.559H155.082V181.002H153.664V168.263L156.501 168.281ZM156.119 174.285C157.277 174.285 157.919 173.92 157.919 172.548V171.303C157.919 170.145 157.502 169.566 156.449 169.566H155.065V174.279L156.119 174.285Z",
    fill: "#6E66FA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.802 197.359V198.517H107.482V197.295C107.482 196.137 107.025 195.459 105.988 195.459C104.952 195.459 104.494 196.148 104.494 197.295V204.017C104.494 205.175 104.969 205.853 105.988 205.853C107.007 205.853 107.482 205.164 107.482 204.017V202.361H108.825V203.942C108.825 205.87 107.916 207.144 105.93 207.144C103.944 207.144 103.076 205.87 103.076 203.942V197.359C103.076 195.43 103.985 194.157 105.93 194.157C107.876 194.157 108.802 195.43 108.802 197.359Z",
    fill: "#6E66FA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.983 197.359C109.983 195.413 110.95 194.157 112.878 194.157C114.806 194.157 115.808 195.413 115.808 197.359V203.942C115.808 205.87 114.841 207.144 112.878 207.144C110.915 207.144 109.983 205.87 109.983 203.942V197.359ZM111.384 204.017C111.384 205.175 111.877 205.853 112.896 205.853C113.915 205.853 114.407 205.181 114.407 204.017V197.283C114.407 196.125 113.932 195.448 112.896 195.448C111.859 195.448 111.384 196.137 111.384 197.283V204.017Z",
    fill: "#6E66FA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.425 207.016H117.151V194.278H118.952L121.899 203.484V194.278H123.156V207.016H121.679L118.425 196.722V207.016Z",
    fill: "#6E66FA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.121 197.359V197.7H128.772V197.283C128.772 196.125 128.338 195.465 127.319 195.465C126.3 195.465 125.865 196.137 125.865 197.266C125.865 200.12 130.138 200.393 130.138 203.977C130.138 205.905 129.212 207.161 127.243 207.161C125.275 207.161 124.389 205.905 124.389 203.977V203.253H125.721V204.052C125.721 205.21 126.19 205.87 127.209 205.87C128.228 205.87 128.703 205.198 128.703 204.052C128.703 201.215 124.447 200.943 124.447 197.359C124.447 195.39 125.356 194.174 127.267 194.174C129.177 194.174 130.121 195.413 130.121 197.359Z",
    fill: "#6E66FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.23 207.016V195.575H130.88V194.284H137.011V195.575H134.666V207.016H133.23Z",
    fill: "#6E66FA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.815 194.284C142.813 194.284 143.652 195.303 143.652 197.179V198.221C143.652 199.617 143.16 200.491 142.072 200.838C143.23 201.186 143.67 202.13 143.67 203.496V205.465C143.627 205.987 143.714 206.513 143.925 206.993H142.489C142.286 206.505 142.204 205.974 142.251 205.447V203.444C142.251 202.008 141.58 201.556 140.393 201.556H139.397V206.993H137.978V194.255L140.815 194.284ZM140.451 200.288C141.58 200.288 142.251 199.924 142.251 198.551V197.33C142.251 196.172 141.834 195.593 140.775 195.593H139.397V200.306L140.451 200.288Z",
    fill: "#6E66FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.49 204.017C146.49 205.175 146.941 205.853 147.978 205.853C149.014 205.853 149.454 205.164 149.454 204.017V194.284H150.78V203.942C150.78 205.87 149.888 207.161 147.926 207.161C145.963 207.161 145.088 205.87 145.088 203.942V194.284H146.49V204.017Z",
    fill: "#6E66FA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M157.803 197.359V198.517H156.454V197.295C156.454 196.137 156.003 195.459 154.966 195.459C153.93 195.459 153.472 196.148 153.472 197.295V204.017C153.472 205.175 153.947 205.853 154.966 205.853C155.985 205.853 156.454 205.164 156.454 204.017V202.361H157.803V203.942C157.803 205.87 156.894 207.144 154.908 207.144C152.922 207.144 152.054 205.87 152.054 203.942V197.359C152.054 195.43 152.963 194.157 154.908 194.157C156.854 194.157 157.803 195.43 157.803 197.359Z",
    fill: "#6E66FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160.947 207.016V195.575H158.631V194.284H164.74V195.575H162.424V207.016H160.947Z",
    fill: "#6E66FA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M167.12 194.284V207.022H165.701V194.284H167.12Z",
    fill: "#6E66FA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.457 197.359C168.457 195.413 169.424 194.157 171.352 194.157C173.28 194.157 174.282 195.413 174.282 197.359V203.942C174.282 205.87 173.315 207.144 171.352 207.144C169.389 207.144 168.457 205.87 168.457 203.942V197.359ZM169.858 204.017C169.858 205.175 170.35 205.853 171.37 205.853C172.389 205.853 172.881 205.181 172.881 204.017V197.283C172.881 196.125 172.406 195.448 171.37 195.448C170.333 195.448 169.858 196.137 169.858 197.283V204.017Z",
    fill: "#6E66FA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.899 207.016H175.625V194.278H177.426L180.373 203.484V194.278H181.63V207.016H180.153L176.899 196.722V207.016Z",
    fill: "#6E66FA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.524 184.4H95.1607V189.907H187.524V184.4Z",
    fill: "#DAD8FE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M131.285 184.4H125.136L121.98 189.901H128.129L131.285 184.4Z",
    fill: "#6E66FA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M187.524 189.901V184.933L184.675 189.901H187.524Z",
    fill: "#6E66FA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M143.82 184.4H137.671L134.522 189.901H140.671L143.82 184.4Z",
    fill: "#6E66FA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M118.744 184.4H112.595L109.439 189.901H115.594L118.744 184.4Z",
    fill: "#6E66FA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9035 189.901H103.053L106.208 184.4H100.053L96.9035 189.901Z",
    fill: "#6E66FA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M181.438 184.4H175.289L172.14 189.901H178.289L181.438 184.4Z",
    fill: "#6E66FA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M156.362 184.4H150.213L147.057 189.901H153.212L156.362 184.4Z",
    fill: "#6E66FA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M168.903 184.4H162.748L159.598 189.901H165.747L168.903 184.4Z",
    fill: "#6E66FA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1943 196.056L37.3758 256.487H72.6547L56.8362 196.056C56.7401 195.645 56.5078 195.279 56.1772 195.017C55.8467 194.754 55.4372 194.612 55.0152 194.612C54.5933 194.612 54.1838 194.754 53.8532 195.017C53.5227 195.279 53.2904 195.645 53.1943 196.056V196.056Z",
    fill: "#DAD8FE",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3758 256.487H66.1177L51.7468 201.579L37.3758 256.487Z",
    fill: "#6E66FA",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2156 255.161H32.2111C30.932 255.161 29.8951 256.198 29.8951 257.477V257.772C29.8951 259.051 30.932 260.088 32.2111 260.088H76.2156C77.4947 260.088 78.5316 259.051 78.5316 257.772V257.477C78.5316 256.198 77.4947 255.161 76.2156 255.161Z",
    fill: "#DAD8FE",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1556 255.161H32.2111C30.932 255.161 29.8951 256.198 29.8951 257.477V257.772C29.8951 259.051 30.932 260.088 32.2111 260.088H61.1556C62.4347 260.088 63.4716 259.051 63.4716 257.772V257.477C63.4716 256.198 62.4347 255.161 61.1556 255.161Z",
    fill: "#6E66FA",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.687 232.383H66.3435L63.6048 221.914H46.4257L43.687 232.383Z",
    fill: "white",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.687 232.383H59.8123L57.0736 221.914H46.4257L43.687 232.383Z",
    fill: "#BABABA",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M146.324 69.3245C148.307 67.3415 148.307 64.1263 146.324 62.1433C144.341 60.1602 141.126 60.1602 139.142 62.1433C137.159 64.1263 137.159 67.3415 139.142 69.3245C141.126 71.3075 144.341 71.3075 146.324 69.3245Z",
    fill: "white",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M142.877 24.7219V1",
    stroke: "#6E66FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M142.877 40.3898V24.7219",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.008 40.3898L119.334 67.5452H166.095L150.415 40.3898H135.008Z",
    fill: "#DAD8FE",
    stroke: "#6E66FA",
    strokeWidth: 0.972732,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M136.583 40.3898L124.105 67.5452H161.324L148.846 40.3898H136.583Z",
    fill: "#6E66FA",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7754 100.358H34.0986C32.4939 100.358 30.9549 100.995 29.8202 102.13C28.6855 103.264 28.048 104.803 28.048 106.408V221.098L99.7754 100.358Z",
    fill: "#DCE6F2",
    stroke: "#6E66FA",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M185.532 100.358H251.209C252.814 100.358 254.353 100.995 255.487 102.13C256.622 103.264 257.259 104.803 257.259 106.408V221.451L185.532 100.358Z",
    fill: "#DCE6F2",
    stroke: "#6E66FA",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7754 100.358L28.048 221.115",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M185.532 100.358L257.259 221.451",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3469 205.644V111.978H92.6073",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M192.544 111.978H247.961V206.119",
    stroke: "#6E66FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M185.532 100.358L166.095 67.5452H119.334L99.7754 100.358",
    fill: "white",
    fillOpacity: 0.3
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M185.532 100.358L166.095 67.5452H119.334L99.7754 100.358",
    stroke: "#6E66FA",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/under-construction.751804a0f63dce756d800fb718316585.svg";
export { ForwardRef as ReactComponent };